import React, {useState, useRef, useContext} from 'react';
import { Modal, useModalHide } from '../components/Modal';
import { PickFileButton } from '../audience/PIckFileButton';
import { Loading } from '../components/Loading';
import { uploadMedia } from './media-api';
import { MediaContext } from './media-store';

type FormState = "none" | "uploading" | "error"

function AddMediaModal(){
    const [state, setState] = useState<FormState>("none")
    const {state: {mediaList}, dispatch} = useContext(MediaContext);
    const hide = useModalHide();
    
    function pickFile(file:File){
        setState("uploading");
        (async () => {
            try {
                var media = await uploadMedia(file);
                dispatch({type: "setList", payload: [media, ...mediaList]})
                hide();
            }catch(e){
                setState("error")
            }
        })();
    }

    if(state == 'none'){
        return <>
            <p>Escolha o arquivo que deseja enviar (Imagem | Audio | PDF)</p>
            <PickFileButton onFileChosen={pickFile} accept='image/png, image/jpeg, audio/mpeg, audio/ogg, video/mp4, application/pdf' />
        </>
    }

    if(state == "uploading")
        return <>
            <Loading label='Enviando o arquivo...' />
        </>

    return <>Erro ao enviar arquivo</>
}

export function AddMediaButton(){
    const [show, setShow] = useState(false);
    return <>
        <button className='btn btn-primary mt-2 mt-md-0' onClick={() => setShow(true)}><i className='fa fa-cloud-arrow-up'></i> Adicionar Arquivo</button>
        {show && <Modal title="Adicionar Arquivo" onHide={() => setShow(false)}>
                <AddMediaModal />
            </Modal>}
    </>
}